export function OutlineKeyIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9988 8.28C20.9988 11.2032 18.6276 13.5696 15.7092 13.5696C15.0564 13.5696 14.4228 13.4496 13.8468 13.2288C13.3764 13.9008 12.8724 14.28 12.4692 14.5104C11.5476 15.0432 10.7028 15.024 10.4196 15.6864C10.242 16.1136 10.5252 16.272 10.3332 16.6512C9.95398 17.3952 8.66758 17.064 8.30758 17.7984C8.13478 18.144 8.38438 18.2976 8.20198 18.7824C7.97638 19.3776 7.42438 19.6704 7.17478 19.8048C6.17638 20.3472 5.14438 20.0688 5.02918 20.0352C3.55078 19.6128 3.04198 18.144 2.99878 18.0048C5.59078 15.4128 8.19238 12.8112 10.7844 10.2192C10.5444 9.6192 10.4196 8.9664 10.4196 8.2848C10.4196 5.3664 12.7908 3 15.7092 3C18.6276 3 20.9988 5.3664 20.9988 8.2848V8.28Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
